import React, { useEffect, useRef } from 'react';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import Getintouch from '../layouts/Getintouch';
import { Link } from 'react-router-dom';

export const Aboutcreativity = () => {
  const scrollLineRef = useRef(null);
  const centerLineRef = useRef(null);
  const centerLineContainerRef = useRef(null);
  const scrollStartAnchorRef = useRef(null);
  const scrollEndAnchorRef = useRef(null);

  const designSections = [
    {
      title: "Graphic Design",
      text: `At Code Buddy, we craft visually engaging graphic designs that communicate your message, elevate your brand, and captivate your audience. From eye-catching visuals to custom logos and complete branding solutions, our design services bring your ideas to life with creativity, clarity, and impact.`,
      image: process.env.PUBLIC_URL + "/images/vertical1.png",
      reverse: false,
    },
    {
      title: "UI/UX Design",
      text: `UI/UX design is all about crafting intuitive, visually appealing digital experiences that not only look great but also feel natural to use—ensuring every interaction is smooth, efficient, and enjoyable for your users across all devices.`,
      image: process.env.PUBLIC_URL + "/images/vertical2.png",
      reverse: true,
    },
    {
      title: "Website Design",
      text: `Web design combines visual appeal with user-friendly navigation to create custom websites that align with your brand, engage your audience, and communicate your message effectively.`,
      image: process.env.PUBLIC_URL + "/images/vertical3.png",
      reverse: false,
    },
  ];

  useEffect(() => {
    const scrollLine = scrollLineRef.current;
    const centerLine = centerLineRef.current;
    const centerLineContainer = centerLineContainerRef.current;
    const scrollStartAnchor = scrollStartAnchorRef.current;
    const scrollEndAnchor = scrollEndAnchorRef.current;

    if (!scrollLine || !centerLine || !centerLineContainer || !scrollStartAnchor || !scrollEndAnchor) return;

    const getOffsetTop = el => el.getBoundingClientRect().top + window.scrollY;

    const updateScrollLine = () => {
      const scrollY = window.scrollY;
      const startScroll = getOffsetTop(scrollStartAnchor) + scrollStartAnchor.offsetHeight;
      const endScroll = getOffsetTop(scrollEndAnchor);

      if (scrollY >= endScroll - window.innerHeight * 0.9 || scrollY < startScroll) {
        centerLineContainer.style.opacity = '0';
        return;
      }

      centerLineContainer.style.opacity = '1';

      const totalScrollable = endScroll - startScroll;
      const scrolled = scrollY - startScroll;
      const ratio = Math.min(scrolled / totalScrollable, 1);

      const moveSpace = centerLine.offsetHeight - scrollLine.offsetHeight;
      scrollLine.style.top = `${ratio * moveSpace}px`;
    };

    const onScroll = () => requestAnimationFrame(updateScrollLine);
    window.addEventListener('scroll', onScroll);
    updateScrollLine();

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <div>
      <Header />

      <Link class="back-button" to={"/Service"}><i class="fa-solid fa-arrow-left"></i>Back</Link>


      <div className='heading-about'>
        <h3>Every pixel with a purpose</h3>
        <p>Your design is your first impression—make it speak your brand,tell your story,
          and
          drive action</p>
      </div>
      {/* Add scroll anchor element */}
      <div ref={scrollStartAnchorRef} className="heading-about" />

      <div ref={centerLineContainerRef} className="center-line-container">
        <div ref={centerLineRef} className="center-line">
          <div ref={scrollLineRef} className="scroll-line"></div>
        </div>
      </div>

      {designSections.map((section, index) => (
        <div
          key={index}
          className={section.reverse ? "visual-section" : "design-section"}
        >
          {!section.reverse && (
            <div className="text-content">
              <h4>{section.title}</h4>
              <p className="intro-text">
                {section.text}
                <a href="#" className="showcase-btn">
                  Work showcase <span className="arrow">→</span>
                </a>
              </p>
            </div>
          )}

          <div className="image-content">
            <img src={section.image} alt={`${section.title} Sample`} />
          </div>

          {section.reverse && (
            <div className="text-content">
              <h4>{section.title}</h4>
              <p className="intro-text">
                {section.text}
                <a href="#" className="showcase-btn">
                  Work showcase <span className="arrow">→</span>
                </a>
              </p>
            </div>
          )}
        </div>
      ))}

      {/* Add scroll end anchor element */}
      <div ref={scrollEndAnchorRef} className="contact-container" />
      <Getintouch />
      <Footer />
    </div>
  );
};

export default Aboutcreativity;
